export const FIELDS = {
    PROJECT_CODE: "projectCode",
    PURPOSE_OF_ORDERING: "purposeOfOrdering",
} as const;

export const FIELD_IDS = {
    PURPOSE_OF_ORDERING: "purpose_of_ordering",
    EXTERNAL_GUESTS: "external_guests",
    CODES_TO_SWIGGY: "136450",
} as const;

export const DROPDOWN_CLOSE_DELAY = 100;

export const SUGGEST_DROPDOWN_HEIGHT = 300;

export const MULTI_SUGGESTIVE_DROPDOWN_HEIGHT = 350;

// timer in seconds
export const CLOSE_HALFCARD_TIMER = 2;

export const TIMER_TEXT = "Redirecting in {0} secs..";

export const SUBMIT_BUTTON_TEXT = {
    DEFAULT: "Submit details",
    REGULAR: "Submit details & pay ₹{0}",
    DINEOUT: "Proceed to bill upload",
};

export const EXPENSE_CODE_HALF_CARD_TEXTS = {
    TITLE: "Business details",
    PROJECT_CODE_LABEL: "Project Code",
    PROJECT_CODE_LABEL_OPTIONAL: "Project Code (Optional)",
    PURPOSE_OF_ORDERING_LABEL: "Purpose of ordering (Optional)",
    NO_RESULT_FOUND: "No Result Found",
    DESCRIPTION:
        "A clear, legible bill image is mandatory. Swiggy isn't liable for rejections due to unclear or incomplete uploads.",
    BUSINESS_DETAILS_SUBMITTED: "Business details has been submitted successfully",
    INVALID_EMAIL: "Please provide a valid work email",
};
